/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoiceseller2Inputs */

const en_ticketsinvoiceseller2 = /** @type {(inputs: Ticketsinvoiceseller2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller on the invoice`)
};

const de_ticketsinvoiceseller2 = /** @type {(inputs: Ticketsinvoiceseller2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer auf der Rechnung`)
};

/**
* | output |
* | --- |
* | "Seller on the invoice" |
*
* @param {Ticketsinvoiceseller2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoiceseller2 = /** @type {((inputs?: Ticketsinvoiceseller2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoiceseller2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoiceseller2(inputs)
	return de_ticketsinvoiceseller2(inputs)
});
export { ticketsinvoiceseller2 as "ticketsInvoiceSeller" }